// Временные переключатели возможностей сайта.

// Способ получения «В зале» (dine_in): Юпитер поддерживает его, но пока скрыт от посетителей.
// Пока false — кнопка не показывается, сохранённый в сессии dine_in сбрасывается на самовывоз.
// Поставить true, чтобы включить способ.
export const DINE_IN_ENABLED = false
